import { Currency } from "@redotech/money/iso4217/currencies";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum SegmentedCheckoutMetricsInsightsState {
  SUCCESS = "SUCCESS",
  INSUFFICIENT_DATA = "INSUFFICIENT_DATA",
  NOT_AVAILABLE = "NOT_AVAILABLE",
}

export enum ComparedSegmentKind {
  FIRST_TIME_VS_EXISTING_CUSTOMER = "FIRST_TIME_VS_EXISTING_CUSTOMER",
  WEEKDAY_VS_WEEKEND = "WEEKDAY_VS_WEEKEND",
  EAST_COAST_VS_WEST_COAST = "EAST_COAST_VS_WEST_COAST",
}

export enum InsightMetricKind {
  CVR = "CVR",
  AOV = "AOV",
  RPCV = "RPCV",
}

export enum MetricKind {
  PERCENT = "PERCENT",
  CURRENCY = "CURRENCY",
}

const Metric_ = z.object({
  kind: createEnum(MetricKind),
  description: z.string(),
});

const PercentMetric_ = Metric_.extend({
  kind: z.literal(MetricKind.PERCENT),
  value: z.number(),
});

const CurrencyMetric_ = Metric_.extend({
  kind: z.literal(MetricKind.CURRENCY),
  currency: createEnum(Currency),
  value: z.number(),
});

const UnderlyingMetric_ = z.union([PercentMetric_, CurrencyMetric_]);
export type UnderlyingMetric = z.infer<typeof UnderlyingMetric_>;

export const SegmentedCheckoutMetricsInsight_ = z.object({
  insightMetricKind: createEnum(InsightMetricKind),
  comparedSegmentKind: createEnum(ComparedSegmentKind),
  description: z.string(),
  underlyingMetrics: z.object({
    metric1: UnderlyingMetric_,
    metric2: UnderlyingMetric_,
  }),
});
export interface SegmentedCheckoutMetricsInsight
  extends z.infer<typeof SegmentedCheckoutMetricsInsight_> {}

export const GetSegmentedCheckoutMetricsInsightsOutput_ = z.union([
  z.object({
    state: z.literal(SegmentedCheckoutMetricsInsightsState.SUCCESS),
    checkoutCount: z.number(),
    insights: z.array(SegmentedCheckoutMetricsInsight_),
  }),
  z.object({
    state: z.literal(SegmentedCheckoutMetricsInsightsState.INSUFFICIENT_DATA),
  }),
  z.object({
    state: z.literal(SegmentedCheckoutMetricsInsightsState.NOT_AVAILABLE),
  }),
]);
export type GetSegmentedCheckoutMetricsInsightsOutput = z.infer<
  typeof GetSegmentedCheckoutMetricsInsightsOutput_
>;
